import * as TYPE from "../../actions/ActionConstants";

const initialState = {
  loading: false,
  error: false,
  message: "",
  transactions: [],
  transactionById: {},
  totalCount: 0,
};

const transactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPE.IS_FETCHING:
      return {
        ...state,
        error: false,
        message: "",
        loading: action.payload,
      };
    case TYPE.GET_ALL_TRANSACTION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: "Transactions fetch successfully",
        transactions: action.payload.data,
        totalCount: action.payload.total_count,
      };
    case TYPE.GET_ALL_TRANSACTION_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: "Error while fetching transactions",
        transactions: [],
      };
    case TYPE.GET_TRANSACTION_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: "Transaction fetch successfully",
        transactionById: action.payload,
      };
    case TYPE.GET_TRANSACTION_BY_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: "Error while fetching transaction",
        transactionById: {},
      };
    case TYPE.USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
};
export default transactionReducer;
